// 不本地直接引用svg，避免下游无依赖
export {
  ArrowDown,
  ArrowUp,
  CellDown,
  CellUp,
  GlobalAsc,
  GlobalDesc,
  GroupAsc,
  GroupDesc,
  GroupNone,
  Minus,
  Plus,
  SortDown,
  SortUp,
  SortDownSelected,
  SortUpSelected,
  InfoCircle,
  ExpandColIcon,
  Trend,
  DrillDownIcon,
  EyeOutlined,
} from './svgs';
